'use strict';

class UserDialogController {

	constructor($scope, $mdDialog, userButtonsInfo, userInfo, mainTopCtrl) {
		let _self 				= this;
		
		this.$scope 			= $scope;

		this.userButtonsInfo 	= userButtonsInfo;                 
        this.userInfo      		= userInfo;
        this.callFunction		= function (menuItem){
        	mainTopCtrl.onClickElement(menuItem);
	        $mdDialog.hide();
        }

	}

}
